import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
//Custom Components Import
import ProtectedRoutes from "./Utils/ProtectedRoutes/ProtectedRoutes";
//Pages Import
import AddServers from "./Pages/AddServers";
import Coinsreport from "./Pages/Coinsreport";
import Coinsreport1 from "./Pages/Coinsreport1";
import Singlereport from "./Pages/singledaycoinearn";
import userbasedcoinreport from "./Pages/userbasedcoinreport";
import AddCountry from "./Pages/AddCountry";
import ShowCountries from "./Pages/ShowCountries";
import ShowServers from "./Pages/ShowServers";
import EditServers from "./Pages/EditServers";
import Allusers from "./Pages/AllUser";
import Login from "./Pages/Login";
import Userinterests from "./Pages/userInterests";
import EditCountry from "./Pages/EditCountry";
import AddFaq from "./Pages/AddFaq";
import AllFaq from "./Pages/AllFaq";
import AllLessons from "./Pages/AllLessons";
import AllLessonCategories from "./Pages/AlllessonCategories";
import EditFaq from "./Pages/EditFaq";
import EditLesson from "./Pages/EditLesson";
import EditCategory from "./Pages/EditCategory";
import AddCategory from "./Pages/AddCategory";
import AddBlogs from "./Pages/AddBlogs";
import EditCreds from "./Pages/Editcredits";
import AllFeedback from "./Pages/AllFeedback";
import AllFeedback1 from "./Pages/allFeedback1";
import SubsPayPal from "./Pages/SubsPayPal";
import Webapp from "./Pages/Webapp";
import EditBlogs from "./Pages/EditBlogs";
import Coinconsumption from "./Pages/Coinconsumption";
import Coinconsumption1 from "./Pages/Coinconsumption1";
import AddLesson from "./Pages/AddLesson";
import MergeUid from "./Pages/MergeUid";
import Userbasedcoinconsumption from "./Pages/Userbasedcoinconsumption";
import AllBlogs from "./Pages/AllBlogs";
import { QueryClientProvider, QueryClient } from "react-query";
import UploadImg from "./Pages/UploadImg";
import Android from "./Pages/Android";
import Ios from "./Pages/Ios";

const queryClient = new QueryClient();
function App() {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Switch>
            <Route path="/" component={Login} exact />
            <ProtectedRoutes path="/addCountry" component={AddCountry} />
            <ProtectedRoutes path="/addServer" component={AddServers} />
            <ProtectedRoutes path="/showCountries" component={ShowCountries} />
            <ProtectedRoutes path="/showServers" component={ShowServers} />
            <ProtectedRoutes path="/editServers" component={EditServers} />
            <ProtectedRoutes path="/editCountry" component={EditCountry} />
            <ProtectedRoutes path="/addFaq" component={AddFaq} />
            <ProtectedRoutes path="/allFaq" component={AllFaq} />
            <ProtectedRoutes path="/allLessons" component={AllLessons} />
            <ProtectedRoutes
              path="/allLessonCategories"
              component={AllLessonCategories}
            />
            <ProtectedRoutes path="/editFaq" component={EditFaq} />
            <ProtectedRoutes path="/editLesson" component={EditLesson} />
            <ProtectedRoutes path="/addLesson" component={AddLesson} />
            <ProtectedRoutes path="/editCategory" component={EditCategory} />
            <ProtectedRoutes path="/addCategory" component={AddCategory} />
            <ProtectedRoutes path="/addBlogs" component={AddBlogs} />
            <ProtectedRoutes path="/editBlogs" component={EditBlogs} />
            <ProtectedRoutes path="/allBlogs" component={AllBlogs} />
            <ProtectedRoutes path="/getLink" component={UploadImg} />
            {/* <ProtectedRoutes path="/allFeedback" component={AllFeedback} /> */}
            <ProtectedRoutes path="/allFeedback" component={AllFeedback1} />
            <ProtectedRoutes path="/paypal" component={SubsPayPal} />
            <ProtectedRoutes path="/android" component={Android} />
            <ProtectedRoutes path="/ios" component={Ios} />
            <ProtectedRoutes path="/webapp" component={Webapp} />
            <ProtectedRoutes path="/userInterests" component={Userinterests} />
            <ProtectedRoutes path="/allUsers" component={Allusers} />
            <ProtectedRoutes path="/editCredits" component={EditCreds} />
            <ProtectedRoutes path="/coinsreport" component={Coinsreport1} />
            <ProtectedRoutes
              path="/single-day-coin-earn"
              component={Singlereport}
            />
            <ProtectedRoutes
              path="/user-based-coin-earn"
              component={userbasedcoinreport}
            />
            <ProtectedRoutes
              path="/coinsconsumptionreport"
              component={Coinconsumption}
            />
            <ProtectedRoutes
              path="/coinsconsumptionreport1"
              component={Coinconsumption1}
            />
            <ProtectedRoutes
              path="/user-based-coin-consumption"
              component={Userbasedcoinconsumption}
            />
            <ProtectedRoutes path="/MergeUid" component={MergeUid} />

            {/* <Route path="/addCountry" component={AddCountry} /> */}
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}

export default App;
